// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'shipments.folgaAteDialog.title': 'Folga até quando?',
    'shipments.folgaAteDialog.editTitle': 'Alterar fim da folga',
    'shipments.folgaAteDialog.description': 'O conjunto fica em Folga até o fim do dia escolhido. No dia seguinte ele volta a Disponível sozinho.',
    'shipments.folgaAteDialog.set': 'Conjunto',
    'shipments.folgaAteDialog.lastDay': 'Último dia da folga',
    'shipments.folgaAteDialog.pickHint': 'Escolha o último dia de folga',
    'shipments.folgaAteDialog.backOn': 'Volta a Disponível em {{when}}',
    'shipments.folgaAteDialog.invalidDate': 'Informe uma data válida.',
    'shipments.folgaAteDialog.notBeforeToday': 'A folga não pode terminar antes de hoje.',
    'shipments.folgaAteDialog.confirm': 'Confirmar folga',
    'shipments.folgaAteDialog.confirmEdit': 'Salvar data',
  },
  en: {
    'shipments.folgaAteDialog.title': 'Day off until when?',
    'shipments.folgaAteDialog.editTitle': 'Change end of day off',
    'shipments.folgaAteDialog.description': 'The set stays on Day off until the end of the chosen day. On the next day it goes back to Available on its own.',
    'shipments.folgaAteDialog.set': 'Set',
    'shipments.folgaAteDialog.lastDay': 'Last day off',
    'shipments.folgaAteDialog.pickHint': 'Choose the last day off',
    'shipments.folgaAteDialog.backOn': 'Back to Available on {{when}}',
    'shipments.folgaAteDialog.invalidDate': 'Enter a valid date.',
    'shipments.folgaAteDialog.notBeforeToday': 'The day off cannot end before today.',
    'shipments.folgaAteDialog.confirm': 'Confirm day off',
    'shipments.folgaAteDialog.confirmEdit': 'Save date',
  },
  es: {
    'shipments.folgaAteDialog.title': '¿Descanso hasta cuándo?',
    'shipments.folgaAteDialog.editTitle': 'Cambiar fin del descanso',
    'shipments.folgaAteDialog.description': 'El conjunto queda en Descanso hasta el final del día elegido. Al día siguiente vuelve a Disponible solo.',
    'shipments.folgaAteDialog.set': 'Conjunto',
    'shipments.folgaAteDialog.lastDay': 'Último día de descanso',
    'shipments.folgaAteDialog.pickHint': 'Elija el último día de descanso',
    'shipments.folgaAteDialog.backOn': 'Vuelve a Disponible el {{when}}',
    'shipments.folgaAteDialog.invalidDate': 'Informe una fecha válida.',
    'shipments.folgaAteDialog.notBeforeToday': 'El descanso no puede terminar antes de hoy.',
    'shipments.folgaAteDialog.confirm': 'Confirmar descanso',
    'shipments.folgaAteDialog.confirmEdit': 'Guardar fecha',
  },
}
